"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Title = _interopRequireDefault(require("../Typography/Title"));

var _Paragraph = _interopRequireDefault(require("../Typography/Paragraph"));

var _StackingLayout = _interopRequireDefault(require("../Layouts/StackingLayout"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Form Section Component
 */
var FormSection =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormSection, _React$Component);

  function FormSection() {
    _classCallCheck(this, FormSection);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormSection).apply(this, arguments));
  }

  _createClass(FormSection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          title = _this$props.title,
          description = _this$props.description,
          topSection = _this$props.topSection,
          props = _objectWithoutProperties(_this$props, ["className", "children", "title", "description", "topSection"]);

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement("div", _extends({
        className: (0, _classnames.default)(className, "".concat(clsPrfx, "-form-section ").concat(clsPrfx))
      }, props), this.renderTopSection(), this.renderDescription(), this.renderContent());
    }
    /**
     * Render top part of form section
     * @returns {ReactElement} - Top section
     */

  }, {
    key: "renderTopSection",
    value: function renderTopSection() {
      var topSection = this.props.topSection;
      var leftContent = [];
      var rightContent = []; // If topSection.leftContent and title are both defined, title should be on the very left

      var title = this.renderTitle();

      if (title) {
        leftContent.push(title);
      }

      if (topSection) {
        if (topSection.leftContent) {
          leftContent.push(_react.default.createElement("div", {
            key: "topLeftSectionContent"
          }, topSection.leftContent));
        }

        if (topSection.rightContent) {
          rightContent.push(_react.default.createElement("div", {
            key: "topRightSectionContent"
          }, topSection.rightContent));
        }
      }

      var content = null;

      if (leftContent.length && rightContent.length) {
        content = _react.default.createElement(_FlexLayout.default, {
          justifyContent: "space-between"
        }, _react.default.createElement(_FlexLayout.default, null, leftContent), _react.default.createElement(_FlexLayout.default, null, rightContent));
      } else if (rightContent.length) {
        content = _react.default.createElement(_FlexLayout.default, {
          flexDirection: "row-reverse"
        }, rightContent);
      } else if (leftContent.length) {
        content = _react.default.createElement(_FlexLayout.default, null, leftContent);
      }

      if (!content) {
        return null;
      }

      return _react.default.createElement("div", {
        key: "formSectionTopSection",
        className: "form-section-top"
      }, content);
    }
    /**
     * Render title if defined
     * @returns {ReactElement} - Title component
     */

  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var title = this.props.title;

      if (title) {
        return _react.default.createElement(_Title.default, {
          key: "sectionTitle",
          size: _Title.default.SIZES.H3
        }, title);
      }

      return null;
    }
    /**
     * Render description if found
     * @returns {ReactElement} - Description paragraph
     */

  }, {
    key: "renderDescription",
    value: function renderDescription() {
      var description = this.props.description;

      if (description) {
        return _react.default.createElement(_Paragraph.default, {
          className: "form-section-desc"
        }, description);
      }

      return null;
    }
    /**
     * Render content of the form section
     * @returns {ReactElement} - Content of form section
     */

  }, {
    key: "renderContent",
    value: function renderContent() {
      var children = this.props.children;

      if (children) {
        return _react.default.createElement(_StackingLayout.default, {
          className: "form-section-content"
        }, children);
      }

      return null;
    }
  }]);

  return FormSection;
}(_react.default.Component);

exports.default = FormSection;
FormSection.propTypes = {
  /**
   * Items (child nodes).
   */
  children: _propTypes.default.node,

  /**
   * Customize additional class name.
   */
  className: _propTypes.default.string,

  /**
   * Title of section
   */
  title: _propTypes.default.string,

  /**
   * Description of section
   */
  description: _propTypes.default.string,

  /**
   * Top section
   */
  topSection: _propTypes.default.shape({
    /**
     * Custom content on left side of the top section.
     * If title exists, this will appear to the right of it
     */
    leftContent: _propTypes.default.node,

    /**
     * Custom content on right side of the top section.
     * If pagination exists, this will appear to the left of it
     */
    rightContent: _propTypes.default.node
  })
};